import { ReactNode } from "react";

import {
    ApartmentOutlined,
    BellOutlined,
    CheckCircleFilled,
    CopyOutlined,
    DeleteOutlined,
    ExclamationCircleFilled,
    ExportOutlined,
    ImportOutlined,
    InboxOutlined,
    InfoCircleFilled,
    LogoutOutlined,
    ReloadOutlined,
    SaveOutlined,
    SendOutlined,
    UserDeleteOutlined,
    UserSwitchOutlined,
    UsergroupAddOutlined,
    WarningFilled,
} from "@ant-design/icons";

/**
 * The glyphs a dialog can lead with, named after what the dialog does rather
 * than what the icon looks like. antd is the stand-in until we have an icon
 * library — swapping it is this file and nothing else.
 */
export const dialogIcons = {
    archive: <InboxOutlined />,
    assign: <UsergroupAddOutlined />,
    delete: <DeleteOutlined />,
    duplicate: <CopyOutlined />,
    entities: <ApartmentOutlined />,
    export: <ExportOutlined />,
    failure: <ExclamationCircleFilled />,
    import: <ImportOutlined />,
    info: <InfoCircleFilled />,
    logOut: <LogoutOutlined />,
    reassignUser: <UserSwitchOutlined />,
    reminder: <BellOutlined />,
    reopen: <ReloadOutlined />,
    save: <SaveOutlined />,
    send: <SendOutlined />,
    success: <CheckCircleFilled />,
    unassignUser: <UserDeleteOutlined />,
    unsavedChanges: <WarningFilled />,
} satisfies Record<string, ReactNode>;

export type DialogIcon = keyof typeof dialogIcons;
